import { loginUser, setSession } from 'actions'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router'
import { postWithoutSession } from 'services/helpers/fetchMethods'
import LocalUserService from 'services/localUserService'

const userService = new LocalUserService()

const LoginWithToken = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { token } = useParams()

  useEffect(() => {
    localStorage.removeItem('activeHotelMerchantId')

    postWithoutSession('login/login-from-shared-link', {
      magicToken: token,
      geoLocation: {}
    })
      .then(res => {
        if (res.isSuccess) {
          const data = res.result

          localStorage.setItem('activeHotelMerchantId', data.subsidiaryId)

          userService.setCurrentUserInfo(data)
          userService.storeLastUser(data.user)

          dispatch(setSession(data.sessionId))
          dispatch(loginUser(data.user, data.userToken, data.userId, data.sessionId))
        } else {
          history.push('/login')
        }
      })
      .catch(err => {
        console.warn(err)
        history.push('/login')
      })
  }, [history, dispatch, token])

  return <LoadingIndicator />
}

export default LoginWithToken
